import { IGetters } from './getters.types';
import { ITracker } from '@/entities';
import { AppConstants as _app } from '@/shared/app.constants';
import { Utilities as _utils } from '@/shared/utilities';

export const getters: IGetters = {
    
}